import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {getIntlLocale} from "../../lib/getIntlLocale";
import {i18nFormat} from "../../lib/i18nFormat";

export function SelfHostedServerExpirationDate(props) {
  const intlLocale = getIntlLocale();

  const serverExpirationDate = useMemo(() => {
    const UTCTime = props.server.selfHostedServerSubscriptionExpiresAt;
    if (!UTCTime) return null;

    const date = new Date(UTCTime);
    const localeDateString = date.toLocaleDateString(intlLocale, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });

    if (props.server.selfHostedServerSubscriptionActive === false) {
      return i18nFormat("shs.status.expiration-date", {date: localeDateString});
    }
    if (props.server.selfHostedServerSubscriptionType === "monthly") {
      return i18nFormat("shs.status.renewal-date", {date: localeDateString});
    }
    if (props.server.selfHostedServerSubscriptionType === "trial") {
      return i18nFormat("shs.status.end-date", {date: localeDateString});
    }
    return null;
  }, [props.server, intlLocale]);

  if (!serverExpirationDate) {
    return null;
  }

  return (
    <span className={props.className ? props.className : "account-shs-expiration-date"}>{serverExpirationDate}</span>
  )
}

SelfHostedServerExpirationDate.propTypes = {
  className: PropTypes.string,
  server: PropTypes.shape({
    selfHostedServerSubscriptionActive: PropTypes.bool.isRequired,
    selfHostedServerSubscriptionType: PropTypes.oneOf(["trial", "lifetime", "monthly"]).isRequired,
    selfHostedServerSubscriptionExpiresAt: PropTypes.string,
  }).isRequired,
}